import { useParams } from 'react-router-dom';
import { ReportsTicketGroupPage } from 'src/components/ReportsTicketGroupPage';
import { Content } from 'src/contexts/ContentContext';
import { DialogProvider } from 'src/contexts/DialogContext/DialogContext';
import { WarningMessage } from 'src/core/POS/MessageWithIcon';
import { PosSpinner } from 'src/core/POS/PosSpinner';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { useReportConfigsV2 } from 'src/hooks/reportConfigs';
import { LayoutContent } from 'src/navigations/LayoutContent';
import { ContentId } from 'src/utils/constants/contentId';
import { ReportTypesV2 } from 'src/utils/reportsUtils';

import { MainRoute } from '../MainRoute';
import { ReportsTicketGroupContextProviderV2 } from './ReportsTicketGroupContextProviderV2';

export function ReportsTicketGroup() {
  return (
    <LayoutContent mainRoute={MainRoute.ReportsV2}>
      <ReportsTicketGroupContent />
    </LayoutContent>
  );
}

function ReportsTicketGroupContent() {
  const { reportId } = useParams();
  const { reportConfigs, isLoading, isFetching } = useReportConfigsV2({
    reportTypes: [ReportTypesV2.TicketGroup],
  });

  const reportConfig = reportConfigs?.find(
    (r) => r.reportId?.toString() === reportId
  );

  if (reportConfig == null) {
    return isLoading || isFetching ? (
      <PosSpinner />
    ) : (
      <Stack
        width="full"
        direction="column"
        alignItems="center"
        style={{ padding: vars.spacing.xxl }}
      >
        <WarningMessage
          message={<Content id={ContentId.ReportNotAvailable} />}
        />
      </Stack>
    );
  }

  return (
    <ReportsTicketGroupContextProviderV2 reportConfig={reportConfig}>
      <DialogProvider>
        <ReportsTicketGroupPage />
      </DialogProvider>
    </ReportsTicketGroupContextProviderV2>
  );
}
